const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

const partsOf = (day) => {
  if (!day) return null
  const [year, month, date] = String(day).split('-').map(Number)
  return year && month && date ? { year, month, date } : null
}

const formatDay = (day) => {
  const parts = partsOf(day)
  return parts ? `${MONTHS[parts.month - 1]} ${parts.date}, ${parts.year}` : ''
}

export const shortDay = (day, withYear) => {
  const parts = partsOf(day)
  if (!parts) return ''
  const label = `${MONTHS[parts.month - 1]} ${parts.date}`
  return withYear ? `${label} '${String(parts.year).slice(2)}` : label
}

export default formatDay
